import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AsyncState } from '@ralba/shared';
import { core } from '../reducers';
import moment from 'moment';

const coreFeatureSelect = createFeatureSelector<core.CoreState>('core');

const selectIsLoaded = createSelector(
  coreFeatureSelect,
  AsyncState.selectIsLoaded
);

const selectAuth = createSelector(coreFeatureSelect, core.selectAuth);

const selectLocalization = createSelector(
  coreFeatureSelect,
  core.selectLocalization
);

const selectLocalizationLanguages = createSelector(
  coreFeatureSelect,
  core.selectLocalizationLanguages
);

const selectLocalizationValues = createSelector(
  coreFeatureSelect,
  core.selectLocalizationValues
);

const selectLocalizationCurrentLanguage = createSelector(
  coreFeatureSelect,
  core.selectLocalizationCurrentLanguage
);

const selectTranslocoTranslations = createSelector(
  selectIsLoaded,
  selectLocalizationValues,
  selectLocalizationCurrentLanguage,
  (isLoaded, values, current) => ({ isLoaded, translations: values })
);

const selectTranslocoConfig = createSelector(
  selectIsLoaded,
  selectLocalizationLanguages,
  selectLocalizationCurrentLanguage,
  (isLoaded, languages, current) => ({ isLoaded, languages, current })
);

const selectApplicationName = createSelector(
  coreFeatureSelect,
  (s) => s.setting?.values?.["App.HrPortal.ApplicationName"] ?? "HR portál"
);
const selectHelpUrl = createSelector(
  coreFeatureSelect,
  (s) => s.setting?.values?.['TPA.HelpUrl'] ?? null
);

const selectIs2026EmployeeCardEnabled = createSelector(
  coreFeatureSelect,
  (s) => {
    return moment(s.setting?.values?.['TPA.EmployeeCardVersion_2026'] ?? "").isBefore(
      moment()
    )
  }
);

const selectEmployeeCardVersion2026 = createSelector(
  coreFeatureSelect,
  (s) => {
    return s.setting?.values?.['TPA.EmployeeCardVersion_2026'] ?? ""
  }
);

export const CoreSelectors = {
  selectIsLoaded,
  selectAuth,
  selectLocalization,
  selectLocalizationCurrentLanguage,
  selectLocalizationLanguages,
  selectLocalizationValues,
  selectTranslocoTranslations,
  selectTranslocoConfig,
  selectApplicationName,
  selectHelpUrl,
  selectIs2026EmployeeCardEnabled,
  selectEmployeeCardVersion2026
};
